import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ManageComponent } from './manage/manage.component';
import { SessionRoutingModule } from 'projects/app-core/src/app/session/session-routing.module';
import { ManageUserAttributesComponent } from './manage-user-attributes/manage-user-attributes.component';
import { TherapistFeedbackComponent } from './therapist-feedback/therapist-feedback.component';
const routes: Routes = [
  {
    path: 'manage',
    component: ManageComponent,
  },
  {
    path: 'add',
    component: AddComponent,
  },
  {
    path: 'add/:id',
    component: AddComponent,
  },
  {
    path: 'session/admin',
    loadChildren: () => SessionRoutingModule,
  },
  {
    path: 'manage-user-attributes',
    component: ManageUserAttributesComponent,
  },
  {
    path: 'ratings',
    component: TherapistFeedbackComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TherapistRoutingModule {}
